"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2932],{

/***/ 32452:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-logo.c29e0ed5.svg","height":50,"width":322});

/***/ }),

/***/ 90180:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/phone-icon.d8a2bf95.svg","height":42,"width":31});

/***/ }),

/***/ 11667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CallUsNowBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2638);



var CallUsNowBar = function(param) {
    var _title = param.title, title = _title === void 0 ? "Schedule A Brake Repair Or Get A Quote Now." : _title, phoneNumber = param.phoneNumber;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        style: {
            backgroundColor: "#f04f23",
            paddingTop: "3%",
            paddingBottom: "3%"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center hidden sm:flex flex-row items-center justify-center flex-wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "m-0",
                        style: {
                            color: "white",
                            lineHeight: 1.5
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "bg-transparent hover:bg-white hover:text-lime text-white border-white border-4 rounded p-3 ml-5 font-semibold",
                            children: (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .u)(phoneNumber)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sm:hidden text-center px-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        style: {
                            color: "white",
                            lineHeight: 1.5
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "bg-transparent hover:bg-white hover:text-lime text-white border-white border-4 rounded p-3 font-semibold",
                            children: (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .u)(phoneNumber)
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 3210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Container = function(_param) {
    var children = _param.children, className = _param.className, divProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className"
    ]);
    var baseClass = "max-w-screen-xl mx-auto lg:px-5 px-5";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClass, className)
    }, divProps), {
        children: children
    }));
};


/***/ }),

/***/ 59354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faFacebookF.js
var faFacebookF = __webpack_require__(54470);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faTwitter.js
var faTwitter = __webpack_require__(51719);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faInstagram.js
var faInstagram = __webpack_require__(78279);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faSquare.js
var faSquare = __webpack_require__(58708);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
;// CONCATENATED MODULE: ./public/img/nubrakes-logo@white.svg
/* harmony default export */ var nubrakes_logo_white = ({"src":"/_next/static/media/nubrakes-logo@white.4812fe52.svg","height":50,"width":322});
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/components/LocationPage/useGblLocationsByState.ts + 1 modules
var useGblLocationsByState = __webpack_require__(5477);
;// CONCATENATED MODULE: ./src/components/LocationPage/LocationsFooter.tsx





var LocationsFooter = function() {
    var stateLocationMap = (0,useGblLocationsByState/* useGblLocationsByState */.B)("LocationsFooter");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "w-full bg-navy text-white py-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container mx-auto px-4",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-gray-400 font-medium mb-6 uppercase tracking-wider",
                        children: "CONSULTATION LOCATIONS"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "!text-gray-300 mb-12 max-w-3xl",
                        children: "We can provide service at your location, or visit us inside Valvoline for a consultation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8",
                        children: Object.entries(stateLocationMap).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), state = _param[0], cities = _param[1];
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-white font-medium mb-3",
                                        children: state
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "space-y-2 text-gray-700 p-0",
                                        children: cities.map(function(city) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "list-none m-0 p-0 !text-gray-400 hover:text-primary transition-colors text-sm",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/locations/".concat(city.slug.replace(/^\/+/, "")),
                                                    className: "!text-gray-400 hover:text-primary transition-colors text-sm",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        className: "!text-gray-400 hover:text-primary transition-colors text-sm",
                                                        children: [
                                                            city.name,
                                                            " Store #",
                                                            city.storeID
                                                        ]
                                                    })
                                                })
                                            }, "".concat(city.city, "-").concat(city.storeID));
                                        })
                                    })
                                ]
                            }, state);
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Footer.tsx
















function Footer(param) {
    var _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "8558005629" : _phoneNumber, disclaimer = param.disclaimer;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        style: {
            paddingTop: disclaimer ? 0 : "5%",
            paddingBottom: "5%",
            backgroundColor: "#03182a",
            color: "white"
        },
        className: "jsx-cc8ffc157c66adbb",
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "cc8ffc157c66adbb",
                children: "a.jsx-cc8ffc157c66adbb{color:white}.social.jsx-cc8ffc157c66adbb a.jsx-cc8ffc157c66adbb{padding-right:30px}li.jsx-cc8ffc157c66adbb{padding-bottom:5px;padding-top:5px}.footer-col-title.jsx-cc8ffc157c66adbb{text-transform:uppercase;font-size:1rem;letter-spacing:.075rem;margin-bottom:2rem;font-weight:700;color:rgba(255,255,255,.6)}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                children: [
                    !!disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-cc8ffc157c66adbb" + " " + "py-6 md:py-9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                            dangerouslySetInnerHTML: {
                                __html: browser_default().sanitize(disclaimer)
                            },
                            className: "jsx-cc8ffc157c66adbb" + " " + "text-center"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            borderBottom: "1px solid grey",
                            paddingTop: disclaimer ? 0 : "20px",
                            marginBottom: 40
                        },
                        className: "jsx-cc8ffc157c66adbb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-cc8ffc157c66adbb" + " " + "grid grid-cols-1 md:grid-cols-5 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-cc8ffc157c66adbb" + " " + "pb-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        width: 150,
                                        height: "auto"
                                    },
                                    className: "jsx-cc8ffc157c66adbb",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: nubrakes_logo_white,
                                        alt: "NuBrakes Logo Outline"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-cc8ffc157c66adbb",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-col-title",
                                        children: "Company"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        style: {
                                            listStyleType: "none",
                                            paddingLeft: 0
                                        },
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-list",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "https://www.classet.org/org/nubrakes",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Become A Technician"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/about-us/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "About Us"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/reviews/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Reviews"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/blog/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Blog"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/contact/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Contact Us"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/warranty",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Nubrakes Warranty Policy"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://apply.workable.com/nubrakes",
                                                    className: "jsx-cc8ffc157c66adbb",
                                                    children: "Careers"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/privacy-policy",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Privacy Policy"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-cc8ffc157c66adbb",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-col-title",
                                        children: "About Our Services"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        style: {
                                            listStyleType: "none",
                                            paddingLeft: 0
                                        },
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-list",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/services/brake-drum-replacement/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Brake Drum Replacement"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/services/brake-pad-replacement/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Brake Pad Replacement"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/services/brake-rotor-replacement/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Brake Rotor & Disc Replacement"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/services/brake-shoe-replacement/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Brake Shoes Replacement"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-cc8ffc157c66adbb",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-col-title",
                                        children: "Get Service"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        style: {
                                            listStyleType: "none",
                                            paddingLeft: 0
                                        },
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-list",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/cities/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Cities"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/financing/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Financing"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/pricing/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Pricing"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/fleet-service/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Fleet Service"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/brake-repair-near-me/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Brake Repair Near Me"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: {
                                                        pathname: "/get-quote/",
                                                        query: query
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "jsx-cc8ffc157c66adbb",
                                                        children: "Schedule A Repair"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-cc8ffc157c66adbb",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-col-title",
                                        children: "Contact Our Brake Team"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: {
                                            fontSize: 24,
                                            fontWeight: "bold"
                                        },
                                        href: "tel:".concat(phoneNumber),
                                        className: "jsx-cc8ffc157c66adbb",
                                        children: (0,string_utils/* formatPhoneNumber */.u)(phoneNumber)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "jsx-cc8ffc157c66adbb" + " " + "footer-col-title pt-4",
                                        children: "Connect"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-cc8ffc157c66adbb" + " " + "social flex flex-row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                title: "facebook",
                                                href: "https://facebook.com/nubrakes/",
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "jsx-cc8ffc157c66adbb" + " " + "fa-layers fa-fw",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: faSquare/* faSquare */.pL,
                                                            color: "#3b5998",
                                                            transform: "grow-20"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: faFacebookF/* faFacebookF */.AY,
                                                            transform: "grow-11 down-2"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                title: "twitter",
                                                href: "https://twitter.com/nubrakes",
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "jsx-cc8ffc157c66adbb" + " " + "fa-layers fa-fw",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: faSquare/* faSquare */.pL,
                                                            color: "#1dcaff",
                                                            transform: "grow-20"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: faTwitter/* faTwitter */.md,
                                                            transform: "grow-6"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                title: "instagram",
                                                href: "https://www.instagram.com/getnubrakes/",
                                                className: "jsx-cc8ffc157c66adbb",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "jsx-cc8ffc157c66adbb" + " " + "fa-layers fa-fw",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: faSquare/* faSquare */.pL,
                                                            color: "#E1306C",
                                                            transform: "grow-20"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: faInstagram/* faInstagram */.Zz,
                                                            transform: "grow-6"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            borderBottom: "1px solid grey",
                            paddingTop: "20px",
                            marginBottom: 40
                        },
                        className: "jsx-cc8ffc157c66adbb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsFooter, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            borderBottom: "1px solid grey",
                            paddingTop: "20px",
                            marginBottom: 40
                        },
                        className: "jsx-cc8ffc157c66adbb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: "/site-map/",
                            query: query
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "jsx-cc8ffc157c66adbb",
                            children: "Site Map"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginTop: 20
                        },
                        className: "jsx-cc8ffc157c66adbb",
                        children: "\xa9 2023 NuBrakes Mobile Brake Repair Service"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_Footer = (Footer);


/***/ }),

/***/ 22932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.mjs
var fontawesome_svg_core = __webpack_require__(23636);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
// EXTERNAL MODULE: ./src/components/Navbar.tsx
var Navbar = __webpack_require__(97134);
// EXTERNAL MODULE: ./src/components/CallUsNowBar.tsx
var CallUsNowBar = __webpack_require__(11667);
// EXTERNAL MODULE: ./src/components/Footer.tsx + 2 modules
var Footer = __webpack_require__(59354);
// EXTERNAL MODULE: ./src/components/PreviewAlert.tsx
var PreviewAlert = __webpack_require__(78915);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./public/img/nubrakes-logo.svg
var nubrakes_logo = __webpack_require__(32452);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/img/phone-icon.svg
var phone_icon = __webpack_require__(90180);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./src/components/utils/string-utils.ts
var string_utils = __webpack_require__(2638);
// EXTERNAL MODULE: ./src/components/navbarLocale.ts
var navbarLocale = __webpack_require__(32273);
;// CONCATENATED MODULE: ./src/components/NavbarSimple.tsx












var removeBuilderURLParam = function(query) {
    // we pass query to our nav links
    // builder sets the page property on query
    var page = query.page, cities = query.cities, cleanedQuery = (0,_object_without_properties/* default */.Z)(query, [
        "page",
        "cities"
    ]);
    // page removed from visible query
    page || cities ? "cleaned from url" : "no page" // appeasing eslint
    ;
    return cleanedQuery;
};
function NavContents(props) {
    var ui = props.ui;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-base lg:flex-grow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                    className: "mt-4 mb-2 sm:hidden"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-right pr-2 lg:flex lg:flex-col hidden",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "font-bold text-black leading-none text-sm",
                                children: ui.needHelp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "leading-none text-xs text-gray-500",
                                children: ui.callUsNow
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "lg:flex hidden",
                        src: phone_icon/* default */.Z,
                        alt: "Phone Icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "lg:px-2 text-2xl font-bold hover:text-primary text-black ml-2 sm:ml-0",
                        style: {
                            flex: "0 0 auto"
                        },
                        href: "tel:".concat(props.phoneNumber),
                        children: (0,string_utils/* formatPhoneNumber */.u)(props.phoneNumber)
                    })
                ]
            })
        ]
    });
}
var NavbarSimple = function(param) {
    var _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "8558005629" : _phoneNumber, _phoneNumberTxt = param.phoneNumberTxt, phoneNumberTxt = _phoneNumberTxt === void 0 ? "(855) 800-5629" : _phoneNumberTxt, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var ui = navbarLocale/* NAVBAR_UI */.s[locale];
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "sticky top-0 flex items-center justify-between flex-wrap bg-white py-2 px-4 border-b navbar-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center text-white mr-6 cursor-pointer w-1/2 sm:w-1/3 md:w-1/4 lg:w-[210px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: {
                        pathname: "/",
                        query: removeBuilderURLParam(query)
                    },
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "mt-2 px-0 md:px-2 max-w-[210px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "NuBrakes Logo",
                            src: nubrakes_logo/* default */.Z,
                            priority: true
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-between mt-1 lg:hidden hover:cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "tel:".concat(phoneNumber),
                    className: "border border-gray-200 rounded flex justify-center items-center h-8 p-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faPhone */.j1w
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:flex lg:flex-row lg:flex-grow lg:items-center lg:w-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavContents, {
                    query: removeBuilderURLParam(query),
                    phoneNumber: phoneNumber,
                    phoneNumberTxt: phoneNumberTxt,
                    ui: ui
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Layout.tsx












fontawesome_svg_core/* config.autoAddCss */.vc.autoAddCss = false;
var CALL_US_NOW_TITLE = {
    en: "Schedule A Brake Repair Or Get a Quote Now.",
    es: "Agenda un mantenimiento de frenos u obt\xe9n una cotizaci\xf3n ahora."
};
var Layout = function(param) {
    var children = param.children, _showGetQuote = param.showGetQuote, showGetQuote = _showGetQuote === void 0 ? true : _showGetQuote, title = param.title, _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "8558005629" : _phoneNumber, _phoneNumberTxt = param.phoneNumberTxt, phoneNumberTxt = _phoneNumberTxt === void 0 ? "(855) 800-5629" : _phoneNumberTxt, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _showNavBar = param.showNavBar, showNavBar = _showNavBar === void 0 ? true : _showNavBar, _navBarVariant = param.navBarVariant, navBarVariant = _navBarVariant === void 0 ? "default" : _navBarVariant, _preview = param.preview, preview = _preview === void 0 ? false : _preview, _description = param.description, description = _description === void 0 ? "" : _description, _robots = param.robots, robots = _robots === void 0 ? "index, follow" : _robots, ogImage = param.ogImage, footerDisclaimer = param.footerDisclaimer, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale, callUsNowTitle = param.callUsNowTitle;
    var resolvedCallUsTitle = callUsNowTitle !== null && callUsNowTitle !== void 0 ? callUsNowTitle : CALL_US_NOW_TITLE[locale];
    var router = (0,next_router.useRouter)();
    var slug = (0,es/* pipe */.zGw)(util/* removeQueryString */.wK, util/* ensureEndsWithSlash */.Fd)(router.asPath);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        href: "/nubrakes-icon@192x192.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/img/safari-pinned-tab.svg",
                        color: "#ff4400"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/manifest.json"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "business.business"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: ogImage !== null && ogImage !== void 0 ? ogImage : "/img/nubrakes-og-holder.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msvalidate.01",
                        content: "A92E5C3F3CD0F7D6AB9BA88C995E1CD4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: "qu0y9ps1iuqrt526ivxlvnrnor5dkg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://nubrakes.com".concat(slug)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: robots
                    })
                ]
            }),
            showNavBar ? navBarVariant === "default" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* Navbar */.wp, {
                phoneNumber: phoneNumber,
                phoneNumberTxt: phoneNumberTxt,
                locale: locale
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarSimple, {
                phoneNumber: phoneNumber,
                phoneNumberTxt: phoneNumberTxt,
                locale: locale
            }) : null,
            preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewAlert/* PreviewAlert */.n, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            showGetQuote && /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUsNowBar/* CallUsNowBar */.y, {
                title: resolvedCallUsTitle,
                phoneNumber: phoneNumber
            }),
            showFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                phoneNumber: phoneNumber,
                disclaimer: footerDisclaimer
            })
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 5477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ useGblLocationsByState; }
});

// UNUSED EXPORTS: buildStateLocationMap

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/clients/new-backend.client.ts
var new_backend_client = __webpack_require__(36826);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 14 modules
var lib = __webpack_require__(59397);
;// CONCATENATED MODULE: ./src/lib/locations/queries.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getGblLocationBySlug($slug: String!) {\n    getGblLocationBySlug(slug: $slug) {\n      id\n      name\n      slug\n      address\n      city\n      state\n      stateName\n      zip\n      phone\n      fullAddress\n      mapUrl\n      isActive\n      hours {\n        weekday\n        saturday\n        sunday\n      }\n      services\n      storeID\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getGblLocations {\n    getGblLocations {\n      name\n      slug\n      city\n      state\n      stateName\n      storeID\n      isActive\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var GET_GBL_LOCATION_BY_SLUG = (0,lib/* default */.ZP)(_templateObject());
var GET_GBL_LOCATIONS = (0,lib/* default */.ZP)(_templateObject1());

;// CONCATENATED MODULE: ./src/components/LocationPage/useGblLocationsByState.ts





/** Group active GBL locations by full state name (for section headings). */ function buildStateLocationMap(locations) {
    var active = locations.filter(function(l) {
        return l.isActive;
    });
    var grouped = Object.values(active.reduce(function(acc, location) {
        if (!acc[location.state]) {
            acc[location.state] = {
                state: location.stateName,
                locations: []
            };
        }
        acc[location.state].locations.push(location);
        return acc;
    }, {}));
    var unsorted = grouped.reduce(function(acc, group) {
        acc[group.state] = group.locations;
        return acc;
    }, {});
    var sortedEntries = Object.entries(unsorted).sort(function(a, b) {
        return b[1].length - a[1].length;
    });
    return Object.fromEntries(sortedEntries);
}
/**
 * Loads consultation locations from GraphQL and groups them by state name.
 * Safe to use in any client component (no Apollo Provider required).
 */ function useGblLocationsByState() {
    var logLabel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "GblLocations";
    var ref = (0,react.useState)({}), stateLocationMap = ref[0], setStateLocationMap = ref[1];
    (0,react.useEffect)(function() {
        var cancelled = false;
        (0,_async_to_generator/* default */.Z)(function() {
            var data, ref, list, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            new_backend_client/* newBackendClient.query */.t.query({
                                query: GET_GBL_LOCATIONS,
                                fetchPolicy: "network-only"
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (cancelled) return [
                            2
                        ];
                        list = (ref = data === null || data === void 0 ? void 0 : data.getGblLocations) !== null && ref !== void 0 ? ref : [];
                        setStateLocationMap(buildStateLocationMap(list));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error("[".concat(logLabel, "] Failed to load locations from API"), e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            cancelled = true;
        };
    }, []);
    return stateLocationMap;
}


/***/ }),

/***/ 97134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "uZ": function() { return /* binding */ services; },
/* harmony export */   "wp": function() { return /* binding */ Navbar; }
/* harmony export */ });
/* unused harmony exports NavItem, DropDownNavItem */
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _public_img_nubrakes_logo_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32452);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73935);
/* harmony import */ var _public_img_phone_icon_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90180);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59417);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_animate_height__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68133);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73401);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61275);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2638);
/* harmony import */ var _navbarLocale__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32273);
















// TODO: Layout.tsx use the serviceCategory field on the Page Model to generate this data structure
var services = [
    {
        linkTitle: "Brake Pad Replacement",
        link: "/services/brake-pad-replacement",
        groupName: "Brake Services"
    },
    {
        linkTitle: "Brake Rotor Replacement",
        link: "/services/brake-rotor-replacement/",
        groupName: "Brake Services"
    },
    {
        linkTitle: "Brake Fluid Flush",
        link: "/services/brake-fluid-flush",
        groupName: "Brake Services"
    },
    {
        linkTitle: "Brake Shoe Replacement",
        link: "/services/brake-shoe-replacement/",
        groupName: "Brake Services"
    },
    {
        linkTitle: "Brake Drum Replacement",
        link: "/services/brake-drum-replacement/",
        groupName: "Brake Services"
    },
    {
        linkTitle: "Brake Hose Replacement",
        link: "/services/brake-hose-replacement/",
        groupName: "Brake Services"
    },
    {
        linkTitle: "Brake Caliper Replacement",
        link: "/services/brake-caliper-replacement/",
        groupName: "Brake Services"
    },
    {
        linkTitle: "Windshield Wiper Fluid Fill",
        link: "/services/windshield-wiper-fluid-fill/",
        groupName: "Wipers"
    },
    {
        linkTitle: "Windshield Wiper Replacement",
        link: "/services/windshield-wiper-replacement/",
        groupName: "Wipers"
    },
    {
        linkTitle: "Wheel Cylinder Replacement",
        link: "/services/wheel-cylinder-replacement/",
        groupName: "Brake Services"
    },
    // { linkTitle: 'Oil Change', link: '/services/oil-change/', groupName: 'General Maintenance' },
    {
        linkTitle: "Tire Rotation",
        link: "/services/tire-rotation/",
        groupName: "General Maintenance"
    },
    // { linkTitle: 'Check Engine Light', link: '/services/check-engine-light', groupName: 'General Maintenance' },
    // {
    //   linkTitle: 'General Maintenance Package',
    //   link: '/services/general-maintenance-package',
    //   groupName: 'General Maintenance',
    // },
    // { linkTitle: 'Brake Light Bulb Replacement', link: '/services/brake-light-bulb-replacement/', groupName: 'Lights' },
    // { linkTitle: 'Turn Signal Bulb Replacement', link: '/services/turn-signal-bulb-replacement/', groupName: 'Lights' },
    // { linkTitle: 'Tail Light Bulb Replacement', link: '/services/tail-light-bulb-replacement/', groupName: 'Lights' },
    // { linkTitle: 'Headlight Bulb Replacement', link: '/services/headlight-bulb-replacement/', groupName: 'Lights' },
    {
        linkTitle: "Car Battery Replacement",
        link: "/services/battery-replacement/",
        groupName: "Car Batteries"
    },
    {
        linkTitle: "Cabin Air Filter Replacement",
        link: "/services/cabin-air-filter-replacement/",
        groupName: "Filters"
    },
    {
        linkTitle: "Engine Air Filter Replacement",
        link: "/services/engine-air-filter-replacement/",
        groupName: "Filters"
    }, 
];
var removeBuilderURLParam = function(query) {
    // we pass query to our nav links
    // builder sets the page property on query
    var page = query.page, cities = query.cities, cleanedQuery = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(query, [
        "page",
        "cities"
    ]);
    // page removed from visible query
    page || cities ? "cleaned from url" : "no page" // appeasing eslint
    ;
    return cleanedQuery;
};
function NavContents(props) {
    var ref // Toggle to turn off the services links
     = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(true), dropDownEnabled = ref[0], setDropDownEnabled = ref[1];
    var isSubNavOpen = props.isSubNavOpen, setSubNavOpen = props.setSubNavOpen, isOpen = props.isOpen, ui = props.ui, localizedServices = props.localizedServices, backLabel = props.backLabel;
    react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
        setDropDownEnabled(true) // toggle off the services drop
        ;
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-base lg:flex-grow",
                children: [
                    dropDownEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropDownNavItem, {
                        onClick: function() {
                            setSubNavOpen(!isSubNavOpen);
                        },
                        text: ui.autoServices,
                        isSubNavOpen: isSubNavOpen,
                        isOpen: isOpen,
                        subPages: localizedServices,
                        setSubNavOpen: setSubNavOpen,
                        backLabel: backLabel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                        href: {
                            pathname: "/reviews/",
                            query: props.query
                        },
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavItem, {
                            text: ui.reviews
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavItem, {
                        href: "https://www.indeed.com/cmp/Nubrakes-Mobile-Brake-Repair",
                        text: ui.becomeTechnician
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "sm:hidden",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: {
                                pathname: "/get-quote/",
                                query: props.query
                            },
                            passHref: true,
                            prefetch: false,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavItem, {
                                text: ui.getQuote
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: "mt-4 mb-2 sm:hidden"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-right pr-2 xl:flex xl:flex-col hidden",
                        style: {
                            flex: "0 0 auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "font-bold text-black leading-none text-sm",
                                children: ui.needHelp
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "leading-none text-xs text-gray-500",
                                children: ui.callUsNow
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: "xl:flex hidden ",
                        src: _public_img_phone_icon_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                        alt: "Phone Icon"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "lg:px-2 text-2xl font-bold hover:text-primary text-black ml-2 sm:ml-0",
                        style: {
                            flex: "0 0 auto"
                        },
                        href: "tel:".concat(props.phoneNumber),
                        children: (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_14__/* .formatPhoneNumber */ .u)(props.phoneNumber)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden xl:flex lg:ml-3 flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                    href: {
                        pathname: "/get-quote/",
                        query: props.query
                    },
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "flex flex-grow",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "flex flex-grow justify-center bg-lime hover:bg-green-600 text-white py-2 text-xs font-semibold px-5 rounded",
                            children: ui.getAQuote
                        })
                    })
                })
            })
        ]
    });
}
var Navbar = function(param) {
    var _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "8558005629" : _phoneNumber, _phoneNumberTxt = param.phoneNumberTxt, phoneNumberTxt = _phoneNumberTxt === void 0 ? "(855) 800-5629" : _phoneNumberTxt, _locale = param.locale, locale = _locale === void 0 ? "en" : _locale;
    var ui = _navbarLocale__WEBPACK_IMPORTED_MODULE_12__/* .NAVBAR_UI */ .s[locale];
    var localizedServices = (0,_navbarLocale__WEBPACK_IMPORTED_MODULE_12__/* .getServicesForLocale */ .t)(services, locale);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isSubNavOpen = ref1[0], setSubNavOpen = ref1[1];
    // const toggle = () => setOpen(!isOpen)
    var closeNav = function() {
        return setOpen(false);
    };
    var openNav = function() {
        return setOpen(true);
    };
    var height = isOpen ? "auto" : 0;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_10__/* .useQueryParam */ .W)();
    var navItemContainerClasses = "w-full block flex-grow lg:flex lg:items-center lg:w-auto";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: "sticky top-0 flex items-center justify-between flex-wrap bg-white py-2 px-4 border-b navbar-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center text-white mr-6 cursor-pointer w-1/2 sm:w-1/3 md:w-1/4 lg:w-[210px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                    href: {
                        pathname: "/",
                        query: removeBuilderURLParam(query)
                    },
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "mt-2 px-0 md:px-2 max-w-[210px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            alt: "NuBrakes Logo",
                            src: _public_img_nubrakes_logo_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                            priority: true
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex items-center justify-between mt-1 mr-4 block lg:hidden hover:cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        className: "border border-gray-200 rounded flex justify-center items-center h-8 mr-3 p-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__/* .FontAwesomeIcon */ .G, {
                            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faPhone */ .j1w
                        })
                    }),
                    !isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function() {
                            openNav();
                        },
                        className: "flex items-center px-2 py-2 border rounded text-gray-500 border-gray-200",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                            className: "fill-current h-4 w-8",
                            viewBox: "0 0 20 20",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                    children: ui.menu
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function() {
                            closeNav();
                            setSubNavOpen(false);
                        },
                        className: "flex items-center py-0 px-2 border rounded text-gray-500 border-gray-200",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "icon icon-close fill-current h-8 w-8",
                            "aria-label": ui.close,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                                xlinkHref: "#icon-close"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        style: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("symbol", {
                            id: "icon-close",
                            viewBox: "0 0 53.7 53.7",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                    children: ui.close
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M35.6 34.4L28 26.8l7.6-7.6c.2-.2.2-.5 0-.7l-.5-.5c-.2-.2-.5-.2-.7 0l-7.6 7.6-7.5-7.6c-.2-.2-.5-.2-.7 0l-.6.6c-.2.2-.2.5 0 .7l7.6 7.6-7.6 7.5c-.2.2-.2.5 0 .7l.5.5c.2.2.5.2.7 0l7.6-7.6 7.6 7.6c.2.2.5.2.7 0l.5-.5c.2-.2.2-.5 0-.7z"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animate_height__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_9___default()("lg:hidden", navItemContainerClasses),
                height: height,
                duration: 350,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavContents, {
                    setSubNavOpen: setSubNavOpen,
                    isSubNavOpen: isSubNavOpen,
                    setOpen: setOpen,
                    isOpen: isOpen,
                    query: removeBuilderURLParam(query),
                    phoneNumber: phoneNumber,
                    phoneNumberTxt: phoneNumberTxt,
                    ui: ui,
                    localizedServices: localizedServices,
                    backLabel: ui.back
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden lg:flex lg:flex-row lg:flex-grow lg:items-center lg:w-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavContents, {
                    setSubNavOpen: setSubNavOpen,
                    isSubNavOpen: isSubNavOpen,
                    setOpen: setOpen,
                    isOpen: isOpen,
                    query: removeBuilderURLParam(query),
                    phoneNumber: phoneNumber,
                    phoneNumberTxt: phoneNumberTxt,
                    ui: ui,
                    localizedServices: localizedServices,
                    backLabel: ui.back
                })
            })
        ]
    });
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line react/display-name
var NavItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(param, ref) {
    var text = param.text, onClick = param.onClick, href = param.href;
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        onClick: onClick,
        ref: ref,
        className: "block mt-4 text-base lg:inline-block font-semibold lg:mt-0 text-nugrey hover:text-black hover:no-underline mr-4",
        children: text
    }));
});
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line react/display-name
var DropDownNavItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(param, ref) {
    var text = param.text, onClick = param.onClick, isOpen = param.isOpen, subPages = param.subPages, isSubNavOpen = param.isSubNavOpen, _backLabel = param.backLabel, backLabel = _backLabel === void 0 ? "BACK" : _backLabel;
    return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "wrapper inline-block relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "#",
                onClick: function(e) {
                    e.preventDefault();
                    onClick();
                },
                ref: ref,
                className: classnames__WEBPACK_IMPORTED_MODULE_9___default()({
                    "trigger block mt-4 text-base lg:inline-block font-semibold lg:mt-0 text-nugrey hover:text-black hover:no-underline mr-4 hover:cursor-pointer": true,
                    "is-active": isSubNavOpen
                }),
                children: text
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DropDownList, {
                onClick: onClick,
                isSubNavOpen: isSubNavOpen,
                isOpen: isOpen,
                subPages: subPages !== null && subPages !== void 0 ? subPages : [],
                backLabel: backLabel,
                renderSubPage: function(page, index) {
                    return generatePage(page, index);
                }
            })
        ]
    }));
});
var generatePage = function(page, index) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        className: "text-sm",
        href: page.link,
        children: page.linkTitle
    }, "page-link-" + index);
};
var toggleHiddenNext = function(target) {
    var next = target.nextSibling;
    if (next.classList.contains("is-hidden")) {
        next.classList.remove("is-hidden");
    } else {
        next.classList.add("is-hidden");
    }
};
function DropDownList(param) {
    var isOpen = param.isOpen, subPages = param.subPages, renderSubPage = param.renderSubPage, onClick = param.onClick, isSubNavOpen = param.isSubNavOpen, backLabel = param.backLabel;
    var byGroup = function(subPages) {
        return (0,ramda__WEBPACK_IMPORTED_MODULE_11__/* .groupBy */ .vMG)((0,ramda__WEBPACK_IMPORTED_MODULE_11__/* .prop */ .vgT)("groupName"), subPages);
    };
    var linkCategories = byGroup(subPages);
    var linkCategoryKeys = Object.keys(linkCategories);
    return(// Portal takes the nav panel out of the regular document flow so it can be utilized at will in the UI
    // Portal maintains access to its react hierarchy and  state
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactPortal, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
            className: classnames__WEBPACK_IMPORTED_MODULE_9___default()({
                "bg-white dropdown-menu": true,
                "is-active": isSubNavOpen
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: classnames__WEBPACK_IMPORTED_MODULE_9___default()({
                    "service-group": true,
                    "is-hidden": !isOpen
                }),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: "text-base font-bold go-back has-children",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            onClick: function(e) {
                                e.preventDefault();
                                onClick();
                            },
                            className: "text-gray-500",
                            href: "#0",
                            children: backLabel
                        })
                    }, "back-button"),
                    linkCategoryKeys.map(function(linkCategory, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "text-lg font-bold group-title has-children",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: "#0",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        toggleHiddenNext(e.target);
                                    },
                                    className: "text-nugray text-base uppercase title-link",
                                    children: [
                                        linkCategory,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_9___default()({
                                        "nested-dropdown secondary-dropdown": true,
                                        "is-hidden": isOpen
                                    }),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                onClick: function(e) {
                                                    var target = e.target;
                                                    target.parentElement.closest("ul").classList.add("is-hidden");
                                                },
                                                className: "go-back text-base relative",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                    },
                                                    className: "text-gray-500",
                                                    href: "#0",
                                                    children: backLabel
                                                })
                                            }),
                                            linkCategories[linkCategory].map(function(page, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "uppercase text-base",
                                                    children: renderSubPage(page, index)
                                                }, "link-" + index);
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, i);
                    })
                ]
            })
        })
    }));
}
function ReactPortal(param) {
    var children = param.children, _wrapperId = param.wrapperId, wrapperId = _wrapperId === void 0 ? "react-portal-wrapper" : _wrapperId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var element = document.getElementById(wrapperId);
        if (!element) {
            element = createWrapperAndAppendToBody(wrapperId);
        }
        setMounted(true);
    }, [
        wrapperId
    ]);
    if (!mounted) return null;
    var element = document.getElementById(wrapperId);
    return element ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_4__.createPortal)(children, element) : null;
}
function createWrapperAndAppendToBody(wrapperId) {
    if (true) {
        var wrapper = document.createElement("div");
        wrapper.id = wrapperId;
        document.body.appendChild(wrapper);
        return wrapper;
    }
}


/***/ }),

/***/ 78915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ PreviewAlert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3210);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




var PreviewAlert = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-screen border-black bg-yellow-500",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "py-2 text-center text-sm",
                children: [
                    "This is a page preview",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/api/exit-preview",
                        as: {
                            pathname: "/api/exit-preview"
                        },
                        children: "Click here"
                    }),
                    " ",
                    "to exit preview"
                ]
            })
        })
    });
};


/***/ }),

/***/ 36826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ newBackendUri; },
/* harmony export */   "t": function() { return /* binding */ newBackendClient; }
/* harmony export */ });
/* harmony import */ var apollo_boost__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24285);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63144);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__);


var newBackendUri = "https://nubrakes-ops-backend-7frr.onrender.com/graphql";
var newBackendClient = new apollo_boost__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP({
    uri: newBackendUri,
    fetch: (isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default())
});


/***/ }),

/***/ 32273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ NAVBAR_UI; },
/* harmony export */   "t": function() { return /* binding */ getServicesForLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var NAVBAR_UI = {
    en: {
        autoServices: "AUTO SERVICES",
        reviews: "REVIEWS",
        becomeTechnician: "BECOME A TECHNICIAN",
        getQuote: "GET QUOTE",
        getAQuote: "GET A QUOTE",
        needHelp: "NEED HELP?",
        callUsNow: "Call us now:",
        back: "BACK",
        menu: "Menu",
        close: "Close"
    },
    es: {
        autoServices: "SERVICIOS AUTOMOTRICES",
        reviews: "RESE\xd1AS",
        becomeTechnician: "\xdaNETE COMO T\xc9CNICO",
        getQuote: "COTIZACI\xd3N",
        getAQuote: "SOLICITAR COTIZACI\xd3N",
        needHelp: "\xbfNECESITAS AYUDA?",
        callUsNow: "Ll\xe1manos:",
        back: "ATR\xc1S",
        menu: "Men\xfa",
        close: "Cerrar"
    }
};
var GROUP_NAME_ES = {
    "Brake Services": "Mantenimiento de frenos",
    Wipers: "Limpiaparabrisas",
    "General Maintenance": "Mantenimiento general",
    "Car Batteries": "Bater\xedas",
    Filters: "Filtros"
};
var normalizeLink = function(link) {
    return link.replace(/\/$/, "") || "/";
};
var SERVICE_TITLE_ES = {
    "/services/brake-pad-replacement": "Reemplazo de pastillas de freno",
    "/services/brake-rotor-replacement": "Reemplazo de discos de freno",
    "/services/brake-fluid-flush": "Limpieza de l\xedquido de frenos",
    "/services/brake-shoe-replacement": "Reemplazo de zapatas de freno",
    "/services/brake-drum-replacement": "Reemplazo de tambores de freno",
    "/services/brake-hose-replacement": "Reemplazo de mangueras de frenos",
    "/services/brake-caliper-replacement": "Reemplazo de c\xe1liper de freno",
    "/services/windshield-wiper-fluid-fill": "Llenado de l\xedquido limpiaparabrisas",
    "/services/windshield-wiper-replacement": "Reemplazo de limpiaparabrisas",
    "/services/wheel-cylinder-replacement": "Reemplazo de cilindro de rueda",
    "/services/tire-rotation": "Rotaci\xf3n de llantas",
    "/services/battery-replacement": "Reemplazo de bater\xeda",
    "/services/cabin-air-filter-replacement": "Reemplazo de filtro de aire acondicionado",
    "/services/engine-air-filter-replacement": "Reemplazo de filtro de aire del motor"
};
function getServicesForLocale(items, locale) {
    if (locale === "en") return items;
    return items.map(function(item) {
        var key = normalizeLink(item.link);
        var titleEs = SERVICE_TITLE_ES[key];
        var groupEs = GROUP_NAME_ES[item.groupName];
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            linkTitle: titleEs !== null && titleEs !== void 0 ? titleEs : item.linkTitle,
            groupName: groupEs !== null && groupEs !== void 0 ? groupEs : item.groupName
        });
    });
}


/***/ }),

/***/ 2638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ toNameUpper; },
/* harmony export */   "u": function() { return /* binding */ formatPhoneNumber; }
/* harmony export */ });
var toNameUpper = function(input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
};
function formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        var intlCode = match[1] ? "+1 " : "";
        return [
            intlCode,
            "(",
            match[2],
            ") ",
            match[3],
            "-",
            match[4]
        ].join("");
    }
    return null;
}


/***/ }),

/***/ 73401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useQueryParam; },
/* harmony export */   "x": function() { return /* binding */ formatQueryParams; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61275);


var useQueryParam = function() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), withSlug = ref.query;
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .dissoc */ .anz)("slug", withSlug);
};
var formatQueryParams = function(query) {
    var pageRemoved = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .omit */ .CEd)([
        "page"
    ], query);
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .keys */ .XPQ)(pageRemoved).reduce(function(prev, cur, i) {
        var symbol = i === 0 ? "?" : "&";
        return "".concat(prev.toString()).concat(symbol).concat(cur.toString(), "=").concat(pageRemoved[cur.toString()]);
    }, "").toString();
};


/***/ }),

/***/ 6069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BI": function() { return /* binding */ getSourceFromPathname; },
/* harmony export */   "Fd": function() { return /* binding */ ensureEndsWithSlash; },
/* harmony export */   "Fj": function() { return /* binding */ getSourceFromUTM; },
/* harmony export */   "Fw": function() { return /* binding */ unflatten; },
/* harmony export */   "Nf": function() { return /* binding */ sendGAEvent; },
/* harmony export */   "UK": function() { return /* binding */ normalizePhone; },
/* harmony export */   "XD": function() { return /* binding */ mapIndexed; },
/* harmony export */   "nO": function() { return /* binding */ flattenObj; },
/* harmony export */   "wK": function() { return /* binding */ removeQueryString; },
/* harmony export */   "xN": function() { return /* binding */ serializeLinkWithParams; }
/* harmony export */ });
/* unused harmony exports useQueryString, logWrapPromise, cleanObject, camelCaseQueryParams, isLandingPage */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61275);





var normalizePhone = function(value) {
    if (!value) {
        return value;
    }
    var onlyNums = value.replace(/[^\d]/g, "");
    if (onlyNums.match(/^1/)) {
        onlyNums = onlyNums.substr(1);
    }
    if (onlyNums.length <= 3) {
        return onlyNums;
    }
    if (onlyNums.length <= 6) {
        return "".concat(onlyNums.slice(0, 3), "-").concat(onlyNums.slice(3));
    }
    return "".concat(onlyNums.slice(0, 3), "-").concat(onlyNums.slice(3, 6), "-").concat(onlyNums.slice(6, 10));
};
var useQueryString = function() {
    var ref = useState(""), queryString = ref[0], setQueryString = ref[1];
    useEffect(function() {
        if (true) {
            setQueryString(window.location.search);
        } else {}
    }, []);
    return queryString;
};
var mapIndexed = (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .addIndex */ .h0F)(ramda__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID);
var ensureEndsWithSlash = function(path) {
    return path.endsWith("/") ? path : "".concat(path, "/");
};
var removeQueryString = function(s) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .head */ .YMb)(s.split("?"));
};
var logWrapPromise = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(promise) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    console.error({
                        e: e
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function logWrapPromise(promise) {
        return _ref.apply(this, arguments);
    };
}();
var getSourceFromPathname = function(pathname) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .cond */ .wVM)([
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("/fb"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("Facebook")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("/streaming"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("Streaming")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("/sem"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("Google SEM")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("/tv"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("tv")
        ],
        [
            ramda__WEBPACK_IMPORTED_MODULE_1__.T,
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("")
        ], 
    ])(pathname);
};
var getSourceFromUTM = function(sourceMedium) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .cond */ .wVM)([
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("google / cpc"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("Google SEM")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("google / GMBlisting"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("GMBlisting")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("fb / cpc"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("Facebook")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("email / manual"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("Email Campaign")
        ],
        [
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .equals */ .fS0)("kvue / display"),
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("KVUE Display")
        ],
        [
            ramda__WEBPACK_IMPORTED_MODULE_1__.T,
            (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .always */ .Bxt)("")
        ], 
    ])(sourceMedium);
};
function sendGAEvent(category, action, label) {
    return _sendGAEvent.apply(this, arguments);
}
function _sendGAEvent() {
    _sendGAEvent = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(category, action, label) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!window["dataLayer"]) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        window["dataLayer"].push({
                            event: "ga-".concat(category),
                            action: action,
                            label: label
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendGAEvent.apply(this, arguments);
}
var flattenObj = function(obj) {
    var go = function(obj_) {
        return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .chain */ .tSV)(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
            if ((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .type */ .dt8)(v) === "Object") {
                return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UID)(function(param) {
                    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), k_ = _param[0], v_ = _param[1];
                    return [
                        "".concat(k, ".").concat(k_),
                        v_
                    ];
                }, go(v));
            } else {
                return [
                    [
                        k,
                        v
                    ]
                ];
            }
        }, (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .toPairs */ .Zpf)(obj_));
    };
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .fromPairs */ .Pen)(go(obj));
};
var unflatten = function(obj) {
    var _loop = function(objectKey) {
        var keys = objectKey.split(".");
        keys.reduce(function(r, e, j) {
            return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? keys.length - 1 === j ? obj[objectKey] : {} : []);
        }, result);
    };
    var result = {};
    for(var objectKey in obj)_loop(objectKey);
    return result;
};
var cleanObject = function(obj) {
    return pipe(flattenObj, reject(isNil), reject(isEmpty), unflatten)(obj);
};
var camelCaseQueryParams = function(s) {
    return s.replace(/-./g, function(x) {
        return x[1].toUpperCase();
    });
};
var serializeLinkWithParams = function(baseUrl, params) {
    return (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .compose */ .qCK)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .concat */ .zoF)(baseUrl), (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .replace */ .gxs)(/^&/, "?"), (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .reduce */ .u4g)(function(acc, val) {
        var key = val[0];
        var value = val[1];
        if (Array.isArray(value)) {
            value.forEach(function(arrayItemValue) {
                if (typeof arrayItemValue !== "string") return;
                acc = acc + "&".concat(key, "=").concat(encodeURIComponent((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .fyY)(arrayItemValue)));
            });
            return acc;
        }
        if (typeof value !== "string") return acc;
        return acc + "&".concat(key, "=").concat(encodeURIComponent((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .fyY)(value))) // value is a string lets encode
        ;
    }, ""), ramda__WEBPACK_IMPORTED_MODULE_1__/* .toPairs */ .Zpf, (0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .reject */ .d1t)((0,ramda__WEBPACK_IMPORTED_MODULE_1__/* .anyPass */ .H50)([
        ramda__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xbD,
        ramda__WEBPACK_IMPORTED_MODULE_1__/* .isNil */ .kKJ
    ])) // &page=['page-name']
    )(params);
};
function isLandingPage(urlPathname) {
    if (urlPathname === "/") return true // Home Page Landing Page Event
    ;
    var landingPagePaths = [
        "/sem/",
        "/cities/",
        "/get-quote/"
    ];
    var landingPage = landingPagePaths.findIndex(function(page) {
        // if the page exists in the landing page paths return true
        return urlPathname.includes(page);
    });
    return landingPage !== -1;
}


/***/ })

}]);